import * as React from "react";
import { Button } from "./button";

type SegmentedControlOption<T extends string> = {
    value: T;
    label: string;
    className?: string;
};

type SegmentedControlProps<T extends string> = {
    options: SegmentedControlOption<T>[];
    value: T;
    onChange: (value: T) => void;
    className?: string;
};

export function SegmentedControl<T extends string>({
    options,
    value,
    onChange,
    className = "",
}: SegmentedControlProps<T>) {
    return (
        <div className={`flex rounded-lg bg-neutral-100 p-1 ${className}`}>
            {options.map((option) => (
                <Button
                    key={option.value}
                    type="button"
                    variant="tab"
                    active={value === option.value}
                    onClick={() => onChange(option.value)}
                    className={option.className}
                >
                    {option.label}
                </Button>
            ))}
        </div>
    );
}
